import React, { useState, useEffect } from 'react';
import api from '../api';
import styles from '../styles/ApiStatusOverview.module.css';

const ApiStatusOverview = () => {
  const [globalStatus, setGlobalStatus] = useState([]);
  const [tableStatus, setTableStatus] = useState([]);
  const [loading, setLoading] = useState({});  // To manage loading state for each table
  const [ttlHours, setTtlHours] = useState(48);

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
      // Fetch global API status
      const globalRes = await api.get('/admin/global_api_status');
      console.log('Global API status:', globalRes.data);
      setGlobalStatus(Array.isArray(globalRes.data) ? globalRes.data : []);

      // Fetch table-specific API statuses
      const tableRes = await api.get('/admin/api_tables_status');
      console.log('API tables status:', tableRes.data);
      setTableStatus(Array.isArray(tableRes.data) ? tableRes.data : []);
    } catch (error) {
      console.error('Error fetching status:', error);
    }
  };

  const handleRefresh = async (tableName) => {
    setLoading((prev) => ({ ...prev, [tableName]: true }));

    try {
      // Make a request to refresh the specific table's data
      await api.post(`/call-api/${tableName}`);
      alert(`${tableName} refreshed successfully!`);

      // Re-fetch the updated statuses
      fetchStatus();
    } catch (error) {
      console.error(`Error refreshing ${tableName}:`, error);
      alert(`Failed to refresh ${tableName}`);
    } finally {
      setLoading((prev) => ({ ...prev, [tableName]: false }));
    }
  };

  const handleTtlUpdate = async () => {
    try {
      await api.put('/update-ttl/live-scoreboard', { ttlHours });
      alert('TTL hours updated successfully');
    } catch (error) {
      console.error('Error updating TTL hours:', error);
      alert('Failed to update TTL hours');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleString();
    } catch {
      return 'Invalid Date';
    }
  };

  return (
    <div className={styles.apiStatusOverview}>
      <h2 className={styles.title}>API Global Status</h2>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Source</th>
            <th>Call Limit Remaining</th>
            <th>Call Limit Reset</th>
          </tr>
        </thead>
        <tbody>
          {globalStatus.length > 0 ? (
            globalStatus.map(status => (
              <tr key={status.api_source || `status-${Date.now()}`}>
                <td>{status?.api_source || 'N/A'}</td>
                <td>{status?.call_limit_remaining ?? 'N/A'}</td>
                <td>{formatDate(status?.call_limit_reset)}</td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="3">Loading data...</td></tr>
          )}
        </tbody>
      </table>

      <h2 className={styles.title}>API Table-Specific Status</h2>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Table Name</th>
            <th>Last Refreshed</th>
            <th>Error Status</th>
            <th>Record Count</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tableStatus.length > 0 ? (
            tableStatus.map(status => (
              <tr key={status.table_name || `table-${Date.now()}`}>
                <td>{status?.table_name || 'N/A'}</td>
                <td>{status?.last_refreshed ?
                    formatDate(new Date(status.last_refreshed).getTime() - 5 * 60 * 60 * 1000) :
                    'N/A'}</td>
                <td>{status?.error_status || 'None'}</td>
                <td>{status?.record_count ?? 'N/A'}</td>
                <td>
                  <button
                    className={styles.refreshButton}
                    onClick={() => handleRefresh(status.table_name)}
                    disabled={loading[status.table_name]}
                  >
                    {loading[status.table_name] ? 'Refreshing...' : 'Refresh'}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="5">Loading data...</td></tr>
          )}
        </tbody>
      </table>

      <h2 className={styles.title}>Live Scoreboard TTL Setting</h2>
      <div>
        <input
          type="number"
          value={ttlHours}
          onChange={(e) => setTtlHours(e.target.value)}
          min="1"
        />
        <button onClick={handleTtlUpdate}>Update TTL Hours</button>
      </div>
    </div>
  );
};

export default ApiStatusOverview;
